"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EllipseChevronRightIcon24 = void 0;
var react_1 = __importDefault(require("react"));
var build_svg_icon_1 = require("../../build-svg-icon");
exports.EllipseChevronRightIcon24 = (0, build_svg_icon_1.buildSvgIcon)(react_1.default.createElement('svg', {
    width: '24',
    height: '25',
    viewBox: '0 0 24 25',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
}, react_1.default.createElement('circle', {
    opacity: '0.9',
    cx: '12',
    cy: '12.75',
    r: '12',
    fill: '#282827',
}), react_1.default.createElement('path', {
    d: 'M10.5012 19.1812C9.94896 19.7729 9.05253 19.7729 8.50026 19.1812C7.94859 18.5895 7.94844 17.6302 8.50026 17.0386L12.5012 12.7525L8.49928 8.4644C7.94721 7.87266 7.94807 6.91349 8.50026 6.32182C9.05239 5.73027 9.94698 5.72957 10.4993 6.32085L15.4993 11.6783C15.6781 11.8699 15.7986 12.1005 15.8616 12.3443C15.9944 12.854 15.8753 13.4238 15.5012 13.8248L10.5012 19.1812Z',
    fill: 'white',
})), 'EllipseChevronRightIcon24', { viewBox: '0 0 24 25' });
exports.default = exports.EllipseChevronRightIcon24;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRWxsaXBzZUNoZXZyb25SaWdodEljb24yNC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2Rlc2lnbi1zeXN0ZW0taWNvbnMvdWktaWNvbnMvMjQvRWxsaXBzZUNoZXZyb25SaWdodEljb24yNC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsZ0RBQTBCO0FBQzFCLHVEQUFvRDtBQUV2QyxRQUFBLHlCQUF5QixHQUFHLElBQUEsNkJBQVksRUFDbkQsZUFBSyxDQUFDLGFBQWEsQ0FDakIsS0FBSyxFQUNMO0lBQ0UsS0FBSyxFQUFFLElBQUk7SUFDWCxNQUFNLEVBQUUsSUFBSTtJQUNaLE9BQU8sRUFBRSxXQUFXO0lBQ3BCLElBQUksRUFBRSxNQUFNO0lBQ1osS0FBSyxFQUFFLDRCQUE0QjtDQUNwQyxFQUNELGVBQUssQ0FBQyxhQUFhLENBQUMsUUFBUSxFQUFFO0lBQzVCLE9BQU8sRUFBRSxLQUFLO0lBQ2QsRUFBRSxFQUFFLElBQUk7SUFDUixFQUFFLEVBQUUsT0FBTztJQUNYLENBQUMsRUFBRSxJQUFJO0lBQ1AsSUFBSSxFQUFFLFNBQVM7Q0FDaEIsQ0FBQyxFQUNGLGVBQUssQ0FBQyxhQUFhLENBQUMsTUFBTSxFQUFFO0lBQzFCLENBQUMsRUFBRSxpWEFBaVg7SUFDcFgsSUFBSSxFQUFFLE9BQU87Q0FDZCxDQUFDLENBQ0gsRUFDRCwyQkFBMkIsRUFDM0IsRUFBRSxPQUFPLEVBQUUsV0FBVyxFQUFFLENBQ3pCLENBQUM7QUFDRixrQkFBZSxpQ0FBeUIsQ0FBQyJ9


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angi/icons/design-system-icons/ui-icons/24/EllipseChevronRightIcon24.js
// module id = 6584
// module chunks = 6